import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { SagaIterator } from 'redux-saga';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
} from 'redux-saga/effects';

import { signUpAPIRequest } from '../api';
import { TSignUpDTO, TSignUpServerResponse } from '../types';
import {
  cancelAuthTask,
  clearError,
  clearSignUpSuccess,
  endAuthTask,
  onError,
  onResetTokenEmail,
  signUpRequest,
  signUpSuccess,
  startAuthTask,
} from './auth-slice';

export function* registerUser(payload: TSignUpDTO): SagaIterator {
  try {
    yield put(startAuthTask());
    const {
      data: { user },
    }: TSignUpServerResponse = yield call(signUpAPIRequest, payload);
    yield all([
      put(signUpSuccess()),
      put(clearError()),
      put(onResetTokenEmail(user)),
    ]);
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield all([put(onError(errorMsg)), put(clearSignUpSuccess())]);
  } finally {
    if (yield cancelled()) {
      yield all([put(clearError()), put(clearSignUpSuccess())]);
    }

    yield put(endAuthTask());
  }
}

export function* signUpFlow(): SagaIterator {
  while (true) {
    const { payload } = yield take(signUpRequest);
    const signUpTask = yield fork(registerUser, payload);

    const nextAction = yield take([cancelAuthTask, endAuthTask]);
    if (nextAction.type === cancelAuthTask.type) yield cancel(signUpTask);
  }
}
